class ColorPickerSidebar {
    constructor() {
        this.ajaxLock = false;
        this.$ = jQuery;
        this.init();
    }

    init() {
        this.events();
    }

    /**
     * Method responsible for events
     * 
     */
    events() {
        let self = this;

        this.$( '.radio-colors' ).is( ':checked', function( e ) {
            e.preventDefault();

            if ( !self.$( '#site-header #color-list' ).hasClass( 'is-active' ) ) {
                self.$( '#site-header #color-list' ).addClass( 'is-active' );
                
                if ( !self.$( '#dark-bg' ).hasClass( 'is-active' ) ) {
                    self.$( '#dark-bg' ).addClass( 'is-active' );
                }
            }
        });

        this.$( '.radio-colors' ).is( ':checked', function() {
            if ( self.$( '#site-header #color-list' ).hasClass( 'is-active' ) ) {
                self.$( '#site-header #color-list' ).removeClass( 'is-active' );
                
                // Trigger only on mobile devices
                if ( 576 > self.$( window ).width() ) {
                    self.$( '#site-header #color-list' ).fadeOut( 100 );
                } else {
                    if ( self.$( '#dark-bg').hasClass( 'is-active' ) ) {
                        self.$( '#dark-bg').removeClass( 'is-active' );
                    }
                }
            }
        });

    }

}

export default ColorPickerSidebar;